import { useEffect, useState } from "react"
import { getinvoices } from "../../services/stripe/StripeServices";
import { fetchAuthSession } from "aws-amplify/auth";
import { Table } from "antd";

export default function CustomerInvoice() {
    const [invoices, setInvoices] = useState([]);
    useEffect(() => {
        fetchAuthSession().then((session) => {
            let tokenv = session.tokens.accessToken.toString();
            getinvoices(tokenv).then(invoices => {
                console.log(invoices);
                setInvoices(invoices);
            })
        })
    }, [])
    const columns = [

        {
            title: 'Invoice No',
            dataIndex: 'invoiceTitle',
            width: 120,

        },
        {
            title: 'Invoice',
            dataIndex: 'hostedInvoiceUrl',
            render: (text, invoice) => {
                if (invoice.hostedInvoiceUrl) {
                    return (
                        <a key={invoice.invoiceId + 'url'} href={invoice.hostedInvoiceUrl} target="">View invoice</a>
                    )
                } else {
                    return <span>No invoice</span>
                }

            }
        }]
    return (
        <Table dataSource={invoices} columns={columns} />
    )
}